import { Text } from '@chakra-ui/react'

import { InlineSkeleton } from '../../components/SkeletonLoader'

interface NullRendererProps {
  size?: string
  styles?: any
  isLoading?: boolean
}

export const NullRenderer = ({
  size,
  styles,
  isLoading,
  ...props
}: NullRendererProps) => {
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <Text size={size} {...props} {...customStyles}>
      <InlineSkeleton isLoading={isLoading}>-</InlineSkeleton>
    </Text>
  )
}
